// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from "@mui/material/Box";
import {CircularProgress
} from "@mui/material";
import {
    deepOrange,
    grey
} from '@mui/material/colors';
import {DataGridPro, GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";

// App Imports
import {
    getContractById, getContractHeaderStandard,
    getSampleContracts
} from "../../Contract/ContractClient";
import {
    getCalcHierarchyAddOn,
    getCalcHierarchyBase
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeFringe} from "./fringeSlice";
import {WorkIssuanceFringeGridColumns} from "./WorkIssuanceFringeGridColumns";
import {changeWorkIssuance} from "../workIssuanceSlice";
import {changeWork} from "../../Work/workSlice";
import LinearIndeterminate from "../../CommonComponents/Progress";
import {changeContractDrilldownExpandCS} from "../../ContractDrilldown/contractDrilldownSliceExpandCS";


// main function
export default function WorkIssuanceFringeGrid(props) {

    // ****************** BEGIN STATES ****************************

    const [contracts, setContracts] = useState([]);
    const [retrievedRows, setRetrievedRows] = useState([0]);
    const [progressSpinner, setProgressSpinner] = React.useState(false);
    const [contractHeader, setContractHeader] = React.useState([]);
    const [selectorContractName, setSelectorContractName] = React.useState([]);
    const [selectorContractHeader, setSelectorContractHeader] = React.useState([]);

    const [submitting, setSubmitting] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorProductId = useSelector((state) => state.fringeSlc.value.myProductId);
    const selectorCdpId = useSelector((state) => state.fringeSlc.value.addOnCdpId);
    const selectorHierarchyLevel = useSelector((state) => state.fringeSlc.value.addOnHierarchyLevel);
    const [selectorMaxId, setSelectorMaxId] = React.useState(0);
    const fetchProductId = useSelector((state) => state.workIssuanceSlc.value.fetchProductId);
    const fetchVersionNumber = useSelector((state) => state.workIssuanceSlc.value.fetchVersionNumber);

    const expandCdpId = useSelector((state) => state.contractDrilldownSlcExpandCS.value.focusCdpId);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchcontractHeaders = () => {
        if (selectorContractId > 0
        ) {
            getContractHeaderStandard(selectorContractId)

                .then(data => {
                    console.log("My header");
                    console.log(data);
                    setContractHeader(data);
                    setSelectorContractName(data[0].name);
                    setSelectorContractHeader(data[0]);
                })}};

    const fetchFringes = () => {
        if (fetchProductId > 0
        ){
            setSubmitting(true);
            console.log("Fringe base fetch triggered.")
            getCalcHierarchyBase(fetchProductId, fetchVersionNumber,"Fringe Amount")

                .then(data => {
                    console.log(data);
                    setContracts(data);
                    const ids = data
                        .filter(item =>
                            data.some(
                                other =>
                                    other.id !== item.id &&
                                    other.hierarchy.includes(item.hierarchy)
                            )
                        )
                        .map(item => item.id);

                    setRetrievedRows(ids);
                    console.log("retrieved row ids:", ids);
                    console.log("length of obligation data:", data.length);
                    const maxId = Math.max(...data.map(item => item.id));
                    setSelectorMaxId(maxId);
                    console.log("max id of obligation data:", maxId);
                    setSubmitting(false);
                })}};

    const fetchMoreFringe = (rowData) => {
        if (rowData.id && !retrievedRows.includes(rowData.id)) {
            setProgressSpinner(true);
            setRetrievedRows((retrievedRows) => [...retrievedRows, rowData.id]);
            console.log("fetching more fringe");
            console.log("selectorCdpId: ", selectorCdpId);
            console.log("selectorHierarchy: ", selectorHierarchyLevel);
            console.log("selectorHierarchyLevel: ", selectorHierarchyLevel);
            console.log("selectorMaxId: ", selectorMaxId);
            getCalcHierarchyAddOn(rowData.cdpId, rowData.hierarchy, rowData.hierarchyLevel, selectorMaxId, "Fringe Amount")

                .then(data => {
                    console.log(data);
                    const ids = data.map(row => row.id);
                    setRetrievedRows((retrievedRows) => [...retrievedRows, ...ids]);
                    console.log("row ids");
                    console.log(ids);
                    setContracts((contracts) => [...contracts, ...data]);
                    console.log("length of fringe data:", data.length);
                    const maxId = Math.max(...data.map(item => item.id));
                    setSelectorMaxId(maxId);
                    console.log("max id of fringe data:", maxId);
                    setProgressSpinner(false);
                })}};


    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        console.log("Loading Contracts Header");
        fetchcontractHeaders()
    }, []);


    useEffect(() => {
        console.log("Loading the contract grid...");
        fetchFringes();
    }, []);


    useEffect(() => {
        console.log("fringes fetch triggered by grid refresh = true");
        fetchFringes();
        dispatchData(changeWorkIssuance({fringeGridRefresh: false}));
    }, [useSelector((state) => state.workIssuanceSlc.value.fringeGridRefresh)===true]);


    useEffect(() => {
        setContracts([]);
        dispatchData(changeWorkIssuance({clearData: false}));
    }, [useSelector((state) => state.workIssuanceSlc.value.clearData)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClickedRow = (rowData) => {
        console.log("clickedRow", rowData);
        console.log("clicked id", rowData.id);
        console.log("clicked cdp_id", rowData.cdpId);
        console.log("clicked cdpv_id", rowData.cdpvId);
        console.log("clicked hierarchy", rowData.hierarchy);
        console.log("clicked hierarchy level", rowData.hierarchyLevel);
        dispatchData(changeFringe({
            addOnCdpId: rowData.cdpId,
            addOnHierarchy: rowData.hierarchy,
            addOnHierarchyLevel: rowData.hierarchyLevel}));
        fetchMoreFringe(rowData);
    }

    // *************** END CONTROLS *******************************


    // ***************************** SOURCE WINDOW ***************************************************************
    //

    // new ChatGpt version
    const openSourceWindow = (sourceRow) => {
        // 1. Build the child URL from wherever we are right now
        const childURL   = `${window.location.origin}/ResidualsFrontend`;
        const childOrigin = new URL(childURL).origin;        // no path, no trailing slash

        console.log("Opening child window at:", childURL);

        // 2. Open the window
        // const newWindow = window.open(childURL, "_blank", "noopener");
        const newWindow = window.open(childURL, "_blank");



        // 3. Local UI update
        dispatchData(changeContractDrilldownExpandCS({ focusCdpId: sourceRow.cdpId }));

        // 4. Prepare exactly your original payload
        const dataToSend = {
            type: "UPDATE_DATA",
            payload: {
                contractId:          sourceRow.sourceContractId,
                contractName:        sourceRow.sourceContractName,
                contractDescription: sourceRow.sourceContractDescription,
                contractSectionId:   sourceRow.sourceSectionId,
                contractSectionName: sourceRow.sourceSection,
                contractDataPointId: sourceRow.sourceContractDataPointId,
                parentSection1Id:    sourceRow.sourceParentSectionId1,
                parentSection2Id:    sourceRow.sourceParentSectionId2,
                parentSection3Id:    sourceRow.sourceParentSectionId3,
                parentSection4Id:    sourceRow.sourceParentSectionId4,
                parentSection5Id:    sourceRow.sourceParentSectionId5,
                parentSection6Id:    sourceRow.sourceParentSectionId6,
                parentSection7Id:    sourceRow.sourceParentSectionId7,
                parentSection8Id:    sourceRow.sourceParentSectionId8,
                parentSection9Id:    sourceRow.sourceParentSectionId9,
                parentSection10Id:   sourceRow.sourceParentSectionId10,
            },
        };

        // const sendMessage = (tag) => {
        //     console.log(">>> sendMessage()", tag, "at", Date.now());
        //     if (newWindow && !newWindow.closed) {
        //         try {
        //             newWindow.postMessage(dataToSend, childOrigin);
        //             console.log("Sent payload to child:", dataToSend);
        //         } catch (err) {
        //             console.error("postMessage failed:", err);
        //         }
        //     }
        // };
        const sendMessage = (tag) => {
            const now = new Date().toLocaleTimeString();
            console.log(`>>> sendMessage(${tag}) at ${now}`);

            if (!newWindow || newWindow.closed) {
                console.warn("newWindow closed or missing");
                return;
            }

            try {
                newWindow.postMessage(dataToSend, childOrigin);
                console.log("✓ Sent payload to child (", tag, ")");
            } catch (err) {
                console.error("✗ postMessage failed (", tag, "):", err);
            }
        };
        // a) try right away (cached fast loads)
        sendMessage("immediate");
        // console.log(">>> sendMessage() called at", Date.now());
        // b) as soon as the document is fully loaded
        // newWindow?.addEventListener("load", sendMessage, { once: true });
        if (newWindow && typeof newWindow.addEventListener === "function") {
            // `{ once: true }` is fine in all modern browsers; remove it for IE11
            newWindow.addEventListener("load", () => sendMessage("load"), { once: true });
        }
        // c) fallback after 5 s if neither of the above hit
        setTimeout(() => sendMessage("timeout"), 5000);
    };


    // ******************************** END SOURCE WINDOW ************************************************



    function DetailPanelContent() {
        return (
            <h2>TEST</h2>
            // <div>{id}</div>
        )}

    const getDetailPanelHeight = React.useCallback(() => 300, []);

    const getDetailPanelContent = React.useCallback(
        ({ row }) => <DetailPanelContent row={contracts.id} />,
        [],
    );


    const getTreeDataPath = (contracts) => contracts.hierarchy.split(',');

    const groupingColDef = {
        hideDescendantCount: true,
        width: 330,
    };


    // ****************** BEGIN RETURN ****************************

    return (
<div>
    {submitting && <LinearIndeterminate/>}
        {progressSpinner &&
        (
            <Box
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor="rgba(255,255,255,0.5)" // optional dimmed overlay
                zIndex={10}
            >
                <CircularProgress />
            </Box>
        )}
        <Box sx={{ height:800 , width: '100%',

            '& .level--1': {backgroundColor: "rgb(30,144,255)"},//https://html-color.codes/blue dodger blue
            '& .level--2': {backgroundColor: "rgb(69,177,232)"},//https://html-color.codes/blue picton blue
            '& .level--3': {backgroundColor: "rgb(135,206,250)"},//https://html-color.codes/blue lightskyblue
            '& .level--4': {backgroundColor: "rgb(137,207,240)"},//https://html-color.codes/blue baby blue
            '& .level--5': {backgroundColor: "rgb(173,216,230)"},//https://html-color.codes/blue light blue
            '& .level--6': {backgroundColor: "rgb(135,206,235)"},//https://html-color.codes/blue skyblue
            '& .level--7': {backgroundColor: "rgb(231,254,255)"},//https://html-color.codes/blue bubbles
            '& .level--8': {backgroundColor: "rgb(244,240,236)"},//https://html-color.codes/grey isabelline
            '& .level--9': {backgroundColor: "rgb(250,250,250)"},//custom
            '& .level--10': {backgroundColor: "rgb(255,255,255)"},//custom
        }}
        >
            {progressSpinner &&
                (
                    <Box
                        position="absolute"
                        top={0}
                        left={0}
                        width="100%"
                        height="100%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bgcolor="rgba(255,255,255,0.5)" // optional dimmed overlay
                        zIndex={10}
                    >
                        <CircularProgress />
                    </Box>
                )}

            <DataGridPro
                experimentalFeatures={{ newEditingApi: true }}
                sx={{
                    '& .MuiDataGrid-detailPanel': {
                        backgroundColor: deepOrange[100],
                    },
                }}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'hierarchyOrder', sort: 'asc' }],
                    }
                    // filter: {
                    //     items: [
                    //         {
                    //             columnField: 'id',
                    //             operatorValue: '==',
                    //             value: '30'
                    //         }]
                    // }
                }}
                treeData
                aria-label={"Contracts"}
                // components={{ Toolbar: GridToolbar }}
                rows={contracts}
                // data={contracts}
                // getRowClassName={(contracts) => `level--${contracts.row.hierarchy.match(/p/g).length+1}`}
                getRowClassName={(contracts) => `level--${contracts.row.hierarchyLevel}`}
                // getDetailPanelHeight={getDetailPanelHeight}
                // onRowClick = {(contracts)=>handleClickedRow(contracts.row)}
                getDetailPanelContent={({ row }) => (
                    <Box sx={{
                        p: 2, flexGrow: 1,
                        bgcolor: deepOrange[100]
                        // backgroundColor: "rgb(255,204,153)"
                    }}>
                        <Box sx={{ml: 2}}>
                            <strong>Expression:</strong> {row.expression}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Translation:</strong> {row.expressionTranslation}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Description:</strong> {row.expressionDescription}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Raw Expression:</strong> {row.rawExpression}
                        </Box>
                    </Box>
                )}
                // getDetailPanelHeight={({ row }) => {
                //     const lineHeight = 24;
                //     const padding = 32;
                //     const brSpacing = 32; // for 2 <br/><br/> lines
                //     const lines = [
                //         row.mockExpression,
                //         row.mockExpressionTranslation,
                //         row.rawExpression,
                //     ].filter(Boolean).length;
                //
                //     return padding + lines * lineHeight + brSpacing;
                // }}
                getDetailPanelHeight={getDetailPanelHeight}
                disableDensitySelector={true}
                disableColumnSelector={true}
                // columns={columns(fetchFringes)}
                columns={WorkIssuanceFringeGridColumns({
                    handleClickedRow,
                    expandCdpId,
                    openSourceWindow
                })}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={contract => contract.id}
                getTreeDataPath={getTreeDataPath}
                groupingColDef={groupingColDef}
                components={{
                    // Toolbar: CustomToolbar,
                    // Footer: CustomFooter,
                }}
            />
        </Box>
</div>
    );

    // ****************** END RETURN ****************************

}



